export const getters = {
  isProviderLoading: state => state.loading,
  profile: state => state.profile,
  profileLoading: state => state.profileLoading,
  announcements: state => state.announcements,
  announcementsLoading: state => state.announcementsLoading,
  games: state => state.games,
  gamesLoading: state => state.gamesLoading,
  services: state => state.services,
  servicesLoading: state => state.servicesLoading,
  availability: state => state.availability,
  availabilityLoading: state => state.availabilityLoading,
  incomingOrders: state => state.incomingOrders,
  responseError: state => state.responseError,
  allowedGames: state => state.allowedGames,
  providerLobbySessions: state => state.providerLobbySessions,
  consumerLobbySessions: state => state.consumerLobbySessions,
  edittingLobbySession: state => state.edittingLobbySession,
};
